import React, { ReactNode } from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  fill?: string;
  children?: ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const ZeroSalesSVG: React.FunctionComponent<StyledProps> = ({
  fill = "black",
  ...props
}) => {
  return (
    <StyledContainer {...props} data-testid="zeroSales-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 64 65"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        data-testid="zeroSales-svg"
      >
        <title>zero-sales</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-480.000000, -429.000000)"
            fill="#64798C"
            fillRule="nonzero"
          >
            <g transform="translate(480.000000, 429.000000)">
              <path
                d="M31.9999213,0.281385228 C49.6557554,0.281385228 63.9685951,14.5942249 63.9685951,32.250059 C63.9685951,49.9058931 49.6557554,64.2187328 31.9999213,64.2187328 C14.3440873,64.2187328 0.0312475413,49.9058931 0.0312475413,32.250059 C0.0312475413,14.5942249 14.3440873,0.281385228 31.9999213,0.281385228 Z M50.2299155,14.0200648 C40.7996402,4.58966353 26.088753,4.08536938 16.0872128,11.9622274 L16.0872128,11.9622274 L25.8272475,21.7023852 L25.3150554,22.2144434 C24.3631121,23.1662875 24.3631121,24.7096903 25.315083,25.661562 L26.9060092,27.2524882 L27.0393739,27.3763976 C27.9058275,28.1237874 29.1733134,28.1611559 30.0798195,27.4884853 L30.215,27.379 L31.944,29.108 L28.2132475,32.8383852 L11.7120897,16.3373505 C3.92241972,26.2283585 4.32736275,40.7315543 13.4687414,50.173955 L13.7699271,50.4800532 C23.2002025,59.9104545 37.9110896,60.4147486 47.9126298,52.5378906 L47.9126298,52.5378906 L31.6602475,36.2853852 L35.391,32.555 L37.12,34.284 L37.0115005,34.4201636 C36.3034128,35.3744682 36.3820877,36.7286568 37.2475115,37.5939905 L38.8384377,39.1849167 C39.7903809,40.13686 41.3337838,40.13686 42.2855839,39.1848615 L42.7972475,38.6723852 L52.2877529,48.1627675 C60.0774229,38.2717595 59.6724799,23.7685637 50.5311012,14.326163 Z M36.4519383,14.5246514 L38.0428807,16.1156625 C38.4090351,16.4817788 38.4090351,17.0753016 38.0428921,17.4414446 L37.1149014,18.3695955 L46.1304498,27.3850661 L47.0585504,26.4571257 C47.424701,26.090937 48.0182238,26.090937 48.3843668,26.45708 L49.9753207,28.0480338 C50.3414042,28.4141555 50.3414042,29.0077209 49.9753207,29.3738044 L41.2248685,38.1242566 C40.8588064,38.4903949 40.2652363,38.4903949 39.8990979,38.1242566 L38.3081441,36.5333027 C37.9420011,36.1671979 37.9420011,35.5736064 38.3081441,35.2074635 L39.2362927,34.279475 L35.3913145,30.4344968 L28.6325402,37.1932712 L29.5606431,38.1213741 C30.146448,38.707179 30.146448,39.6568853 29.5606431,40.2426902 L21.4926463,48.3106871 C20.9068413,48.896492 19.957135,48.896492 19.3713301,48.3106871 L16.1893537,45.1287107 C15.6035488,44.5429058 15.6035488,43.5931995 16.1893537,43.0073945 L24.2572864,34.9393245 C24.8430868,34.3535241 25.7927931,34.3535241 26.378598,34.939329 L27.3067009,35.8674319 L34.0654753,29.1086576 L30.2204971,25.2636794 L29.2924629,26.1918738 C28.9264038,26.557971 28.3328123,26.557971 27.9666694,26.1918281 L26.3757155,24.6008742 C26.0095772,24.234774 26.0095772,23.6412038 26.3756879,23.2751312 L35.1261677,14.5246514 C35.4922725,14.1585085 36.0857953,14.1585085 36.4519383,14.5246514 Z"
                id="zero-sales"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </StyledContainer>
  );
};

export default ZeroSalesSVG;
